// @flow

export const SET_ACTIVE_PDB_ITEM: 'listo/pdb/SET_ACTIVE_PDB_ITEM' = 'listo/pdb/SET_ACTIVE_PDB_ITEM';
export const STORE_PDB_DATA: 'listo/pdb/STORE_PDB_DATA' = 'listo/pdb/STORE_PDB_DATA';
export const GET_PDB_DATA: 'listo/pdb/GET_PDB_DATA' = 'listo/pdb/GET_PDB_DATA';
export const GET_PDB_DATA_SUCCESS: 'listo/pdb/GET_PDB_DATA_SUCCESS' = 'listo/pdb/GET_PDB_DATA_SUCCESS';
export const GET_PDB_DATA_FAILED: 'listo/pdb/GET_PDB_DATA_FAILED' = 'listo/pdb/GET_PDB_DATA_FAILED';

export default null;
